import { QUERY_KEYS } from '@rc-d2c/context-manager';
import { useIsFetching } from '@tanstack/react-query';

export const useIsFetchingRecommendedProducts = () => {
  return !!useIsFetching({ queryKey: QUERY_KEYS.RECOMMENDED_PRODUCTS() });
};
